import { useState, useEffect } from "react";

import Swal from "sweetalert2";

import { db, storage } from "../../../../util/firebase";
import {
  query,
  collection,
  getDocs,
  where,
  doc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";

import { useNavigate, useParams } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { FaChevronLeft } from "react-icons/fa";

import { Button, Input, Modal, ModalBody } from "reactstrap";

import { IoClose } from "react-icons/io5";

function AdminSingleBundlePage() {
  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const params = useParams();
  const bundleUid = params.bundleUid;

  const [bundleObject, setBundleObject] = useState();
  const [image, setImage] = useState("");
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [status, setStatus] = useState("");
  const [addedProducts, setAddedProducts] = useState([]);

  const fetchBundle = async () => {
    try {
      setIsLoading(true);

      const q = query(collection(db, "bundles"), where("uid", "==", bundleUid));
      const doc = await getDocs(q);
      // eslint-disable-next-line
      const data = doc.docs[0]?.data();

      setBundleObject(data);
      setImage(data.image);
      setName(data.name);
      setPrice(data.price);
      setAddedProducts(data.products);
      setStatus(data.status);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching bundle data");
    }
  };

  useEffect(() => {
    if (bundleUid) {
      fetchBundle();
    }
    // eslint-disable-next-line
  }, [bundleUid]);

  const saveChanges = () => {
    Swal.fire({
      text: "Are you sure you want to save your changes to this bundle?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: "YES, SAVE",
      cancelButtonText: "NO, CANCEL",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        try {
          const bundleRef = query(
            collection(db, "bundles"),
            where("uid", "==", bundleUid)
          );
          const findBundles = await getDocs(bundleRef);
          findBundles.forEach(async (bundle) => {
            const getBundle = doc(db, "bundles", bundle.id);
            await updateDoc(getBundle, {
              name: name,
              price: parseFloat(price),
              products: addedProducts,
              status: status,
            }).then(() => {
              fetchBundle();
            });
          });

          setIsLoading(false);
        } catch (err) {
          console.error(err);
          setIsLoading(false);
        }
      }
    });
  };

  const deleteBundle = async () => {
    Swal.fire({
      text: "Are you sure you want to delete this bundle?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: "YES, DELETE",
      cancelButtonText: "NO, CANCEL",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setIsLoading(true);

          const bundleRef = query(
            collection(db, "bundles"),
            where("uid", "==", bundleUid)
          );
          const findBundles = await getDocs(bundleRef);
          findBundles.forEach(async (bundle) => {
            const getBundles = doc(db, "bundles", bundle.id);
            await deleteDoc(getBundles);
          });

          Swal.fire({
            text: "Bundle deleted successfully",
            icon: "success",
            confirmButtonColor: "#005EE1",
            confirmButtonText: "OKAY",
          });

          navigate(-1);

          setIsLoading(false);
        } catch (err) {
          console.error(err);
          alert("An error occured while deleting bundle");
        }
      }
    });
  };

  const [products, setProducts] = useState([]);
  const fetchProducts = async () => {
    try {
      setIsLoading(true);

      const q = query(collection(db, "products"));
      const querySnapshot = await getDocs(q);
      let fetchedProducts = [];
      querySnapshot.forEach((doc) => {
        fetchedProducts.push(doc.data());
      });
      setProducts(fetchedProducts);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching products");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
    // eslint-disable-next-line
  }, []);

  const [productSearchTerms, setProductSearchTerms] = useState("");

  const [addProductModal, setAddProductModal] = useState(false);
  const toggleAddProductModal = () => setAddProductModal(!addProductModal);

  const addProduct = (product) => {
    if (
      addedProducts.find((addedProduct) => addedProduct.uid === product.uid)
    ) {
      Swal.fire({
        text: "Product already added",
        icon: "error",
        confirmButtonColor: "#005EE1",
        confirmButtonText: "OKAY",
      });

      return;
    }
    let newAddedProducts = addedProducts;
    newAddedProducts.push(product);
    setAddedProducts(newAddedProducts);

    toggleAddProductModal();
  };

  const removeProduct = (product) => {
    let newAddedProducts = addedProducts.filter(
      (addedProduct) => addedProduct.uid !== product.uid
    );
    setAddedProducts(newAddedProducts);

    Swal.fire({
      text: "Product removed",
      icon: "success",
      confirmButtonColor: "#005EE1",
      confirmButtonText: "OKAY",
    });
  };

  const [changeBundleImageModalIsOpen, setChangeBundleImageModalIsOpen] =
    useState(false);
  const toggleChangeBundleImageModal = () =>
    setChangeBundleImageModalIsOpen(!changeBundleImageModalIsOpen);

  const [isModalLoading, setIsModalLoading] = useState(false);

  const [newBundleImage, setNewBundleImage] = useState();
  const [newBundleImagePreview, setNewBundleImagePreview] = useState();

  const handleChangeNewBundleImage = (e) => {
    setNewBundleImage(e.target.files[0]);
    setNewBundleImagePreview(URL.createObjectURL(e.target.files[0]));
  };

  const selectNewBundleImage = () => {
    document.getElementById("selectImage").click();
  };

  const handleUploadNewBundleImage = async () => {
    const storageRef = ref(storage, `assets/bundles/${newBundleImage.name}`);
    const uploadTask = uploadBytesResumable(storageRef, newBundleImage);
    setIsModalLoading(true);
    uploadTask.on(
      "state_changed",
      null,
      (error) => console.log(error),
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
          console.log("File available at", downloadURL);
          try {
            setNewBundleImage(downloadURL);

            const bundleRef = query(
              collection(db, "bundles"),
              where("uid", "==", bundleUid)
            );
            const findBundles = await getDocs(bundleRef);
            findBundles.forEach(async (bundle) => {
              const getBundle = doc(db, "bundles", bundle.id);
              await updateDoc(getBundle, {
                image: downloadURL,
              });
            });

            fetchBundle();

            setIsModalLoading(false);
            toggleChangeBundleImageModal();
          } catch (err) {
            console.error(err);
            alert(err.message);
            setIsModalLoading(false);
          }
        });
      }
    );
  };

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="newsArticlePage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        BUNDLE
      </h1>
      <div>
        <div
          onClick={toggleChangeBundleImageModal}
          id="adminNewsArticleImageContainer"
        >
          <img
            alt="newsArticleImage"
            src={
              image
                ? image
                : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
            }
            id="newsArticleImage"
          />
          <div className="adminNewsArticleImageOverlay">
            <Button className="primaryBtn">CHANGE</Button>
          </div>
        </div>
        <Modal
          id="changeNewsArticleImageModal"
          isOpen={changeBundleImageModalIsOpen}
          toggle={toggleChangeBundleImageModal}
          size={"lg"}
        >
          <ModalBody>
            <div className="modalHeader" style={{ marginBottom: "1rem" }}>
              <div></div>
              <IoClose onClick={toggleChangeBundleImageModal} />
            </div>
            <div>
              <h1>CHANGE IMAGE</h1>
              {isModalLoading ? (
                <div
                  style={{
                    height: 300,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <BarLoader color="#005EE1" />
                </div>
              ) : (
                <div style={{ marginTop: "1rem" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: "1rem",
                    }}
                  >
                    <img
                      alt="articleImage"
                      src={
                        newBundleImagePreview
                          ? newBundleImagePreview
                          : image
                          ? image
                          : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                      }
                      style={{ height: 250, width: 651.4 }}
                    />
                  </div>
                  <Input
                    id="selectImage"
                    type="file"
                    className="mainInput"
                    accept="image/*"
                    onChange={handleChangeNewBundleImage}
                    style={{ display: "none" }}
                  />
                  <Button
                    onClick={selectNewBundleImage}
                    className="secondaryBtn"
                    style={{ marginBottom: "0.5rem", color: "#005EE1" }}
                  >
                    {newBundleImage?.name
                      ? newBundleImage.name
                      : "CHOOSE IMAGE"}
                  </Button>
                  <Button
                    onClick={handleUploadNewBundleImage}
                    disabled={!newBundleImage?.name}
                    className="primaryBtn"
                  >
                    CHANGE
                  </Button>
                </div>
              )}
            </div>
          </ModalBody>
        </Modal>
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Name
        </p>
        <input
          type="text"
          className="mainInput"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="The bundle's name"
          style={{ marginBottom: "0.5rem" }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Price
        </p>
        <input
          type="number"
          className="mainInput"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          placeholder="The bundle's price"
          style={{ marginBottom: "0.5rem" }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Status
        </p>
        <Input
          type="select"
          className="mainInput"
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          defaultValue={""}
          style={{ marginBottom: "0.5rem" }}
        >
          <option value="" disabled>
            The bundle's status
          </option>
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
        </Input>
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Products
        </p>
        <Button
          onClick={toggleAddProductModal}
          className="primaryBtn"
          style={{ marginBottom: "0.5rem" }}
        >
          ADD PRODUCT
        </Button>
        <Modal
          id="addProductModal"
          isOpen={addProductModal}
          toggle={toggleAddProductModal}
          size={"lg"}
        >
          <ModalBody>
            <div className="modalHeader">
              <div></div>
              <IoClose onClick={toggleAddProductModal} />
            </div>
            <div>
              <h1>ADD PRODUCT</h1>
              <div style={{ marginTop: "1rem" }}>
                <input
                  type="text"
                  className="mainInput"
                  value={productSearchTerms}
                  onChange={(e) => setProductSearchTerms(e.target.value)}
                  placeholder="Search..."
                  style={{ marginBottom: "1rem" }}
                />
                {productSearchTerms
                  ? products
                      .filter(
                        (product) =>
                          product.name
                            .toLowerCase()
                            .includes(productSearchTerms.toLowerCase()) ||
                          product.category
                            .toLowerCase()
                            .includes(productSearchTerms.toLowerCase())
                      )
                      .map((product, index) => (
                        <div
                          onClick={() => addProduct(product)}
                          key={index}
                          className="bundleProductCard"
                          style={{ cursor: "pointer" }}
                        >
                          <p>
                            <span className="bundleProductCategory">
                              {product.category}
                            </span>
                            &nbsp;
                            <span className="bundleProductName">
                              {product.name}
                            </span>
                          </p>
                          <p className="bundleProductPrice">${product.price}</p>
                        </div>
                      ))
                  : products.map((product, index) => (
                      <div
                        onClick={() => addProduct(product)}
                        key={index}
                        className="bundleProductCard"
                        style={{ cursor: "pointer" }}
                      >
                        <p>
                          <span className="bundleProductCategory">
                            {product.category}
                          </span>
                          &nbsp;
                          <span className="bundleProductName">
                            {product.name}
                          </span>
                        </p>
                        <p className="bundleProductPrice">${product.price}</p>
                      </div>
                    ))}
              </div>
            </div>
          </ModalBody>
        </Modal>
        <div className="addedProducts">
          {addedProducts?.length === 0 ? (
            <p
              style={{
                textAlign: "center",
                marginTop: "0.5rem",
                marginBottom: "0.5rem",
              }}
            >
              No products added
            </p>
          ) : (
            addedProducts?.map((product, index) => (
              <div
                onClick={() => removeProduct(product)}
                key={index}
                className="addedProductCard"
              >
                <p>
                  <span className="bundleProductCategory">
                    {product.category}
                  </span>
                  &nbsp;
                  <span className="bundleProductName">{product.name}</span>
                </p>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <p className="bundleProductPrice">${product.price}</p>
                  <IoClose />
                </div>
              </div>
            ))
          )}
        </div>
        {console.log(addedProducts, bundleObject?.products)}
        <button
          onClick={saveChanges}
          className="primaryBtn"
          style={{ marginTop: "0.5rem" }}
        >
          SAVE
        </button>
        <button
          onClick={deleteBundle}
          className="secondaryBtn"
          style={{ marginTop: "0.5rem" }}
        >
          DELETE
        </button>
      </div>
    </div>
  );
}

export default AdminSingleBundlePage;
